export default __webpack_public_path__ + "static/med-icn-572ebcdf19d8e7b67bc6ac0f619f6fe4.png";